import {
  MarketingHeroContainer,
  MarketingContentContainer,
  MarketingNewsletterCard,
  MarketingNewsletterFormContainer,
  useAnchorScroll,
} from "@platform/features/marketing";
import {
  NewsSectionContainer,
  useHasPublishedNews,
} from "@platform/features/news";

export default function MarketingHome() {
  // A link may point at one section rather than the top of the page.
  useAnchorScroll();
  const { hasPublishedNews } = useHasPublishedNews();

  return (
    <>
      <div className="flex flex-col">
        <MarketingHeroContainer />
        <MarketingContentContainer
          // Offered only once something is published. Without it the content
          // falls back to Get Updates on its own, which is this same band
          // without the posts above it.
          news={
            hasPublishedNews ? (
              <NewsSectionContainer>
                <MarketingNewsletterCard>
                  <MarketingNewsletterFormContainer className="w-full" />
                </MarketingNewsletterCard>
              </NewsSectionContainer>
            ) : undefined
          }
        />
      </div>
    </>
  );
}
